import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators,Dispatch } from "redux";
import { Popup } from "semantic-ui-react";
import classNames from "classnames";
import * as _ from "lodash";
import { parseNameToUrl, parseUrlToName, hasWriteAccess, getIndexedValue, searchMatchRule } from "../../utils/utils";
import ExcelExport from "../../components/ExcelExport/ExcelExport";
import GlobalTableSettings from "../GlobalTableSettings/GlobalTableSettings";
import ActionMenuButton from "../../components/ActionMenuButton/ActionMenuButton";
import NavigationLink from "../../components/NavigationLink/NavigationLink";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import ModifyLiftParameterBindings from "../../components/ModifyLiftParameterBindings/ModifyLiftParameterBindings";
import VersionAndProduct from "../../containers/VersionAndProduct/VersionAndProduct";
import { EditActions, editActions } from "../../actions/editActions";
import { ColumnActions, columnActions } from "../../actions/columnActions";
import {
  editedObjectIdSelector,
  isEditActiveSelector,
  editedObjectIdentifierSelector
} from "../../reducers/editReducer";
import { createEmptyKCEVersion, createEmptyKCEProduct } from "../../utils/pdApiUtils";

import exportIcon from "../../images/export.svg";
import add from "../../images/circle-plus.svg";
import service from "../../images/service-24.png";
import { Column, Filter } from "../../components/Table/Migration/LegacyTypes";
import  styles  from "../../components/ActionMenuButton/ActionMenuButton.module.scss";

type StateProps = {
  columns: State.ColumnMap;
  pdApi: State.PdApi;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
};

type DispatchProps = {
  columnActions: typeof columnActions;
  editActions: typeof editActions;
};

type OwnProps = {
  subMenuRoute: State.KCEVPSubmenu;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  match: any;
  selectedColumnsName: keyof State.ColumnMap;
};

export type LiftBindingsProps = StateProps & DispatchProps & OwnProps;

type LiftBindingsState = {
  activeMenu: State.LiftBindingsSubmenu;
  isModalOpen: boolean;
  tableColumnFilters: {
    [key in State.LiftBindingsSubmenuWithTables]: Filter[];
  };
};

export class LiftBindings extends React.Component<LiftBindingsProps, LiftBindingsState> {
  static subMenus: State.LiftBindingsSubmenu[] = [
    "Add Bindings",
    "Remove Bindings",
    "Products",
    "Versions"
  ];
  state = {
    activeMenu: this.props.match.params.activeMenu
      ? parseUrlToName(this.props.match.params.activeMenu) as State.LiftBindingsSubmenu
      : "Add Bindings",
    isModalOpen: false,
    tableColumnFilters: {
      "Products": [],
      "Versions":[],
    }    
  };

  componentDidUpdate(): void {
    const parseActiveMenuFromURL = this.props.match.params.activeMenu
      ? parseUrlToName(this.props.match.params.activeMenu) as State.LiftBindingsSubmenu
      : "Add Bindings";
    if (this.state.activeMenu !== parseActiveMenuFromURL) {
      this.setState({ activeMenu: parseActiveMenuFromURL });
    }
  }
  
  private setColumnFilters = (subMenuRoute: State.LiftBindingsSubmenu, newFilters: Filter[]): void => {
    const newFilterSet = { ...this.state.tableColumnFilters, [subMenuRoute]: newFilters };
    this.setState(prevState => ({
      ...prevState,
      tableColumnFilters: newFilterSet
    }));
  };

  render(): JSX.Element {
    const { pdApi, columns, mainState, subMenuRoute, isEditActive, objectIdentifier } = this.props;
    const { activeUser } = mainState;
    const { kceProducts, kceVersions } = pdApi;
    const { activeMenu, isModalOpen } = this.state;
    const { liftParameters } = pdApi;

    let rows: Api.AnyVP[] = [];

    switch (activeMenu) {
      case "Products":
        rows = [..._.values(kceProducts)].sort(function (a: Api.KceProduct, b: Api.KceProduct) {
          return a.productNumber - b.productNumber;
        });
        break;
      case "Versions":
        rows = [..._.values(kceVersions)];
        break;
      default:
        rows = [];
    }

    const filteredRows = this.filterWithUserSelection(this.state.tableColumnFilters[activeMenu as State.LiftBindingsSubmenuWithTables], rows);

    const newItem = subMenuRoute === "Products" ? createEmptyKCEProduct() : createEmptyKCEVersion();
    const option: Api.OptionsGrud = activeMenu === "Products" ? "kceProducts" : "kceVersions";
    const filename = activeMenu === "Products" ? "elevator_products"  : activeMenu === "Versions" ? "elevator_versions" : subMenuRoute;
    return (
      <div className="table-container">
        <div className="bindingsWrapper">
          <div className="bindingsTabs">
            {LiftBindings.subMenus.map(menu => (
              <NavigationLink
                key={menu}
                to={"/elevator/bindings/" + parseNameToUrl(menu)}
                name={menu}
              />
            ))}
          </div>
          {(activeMenu === "Versions" || activeMenu === "Products") && (
            <div className="actionsMenu">
              <div className="bindingActions">
              {filteredRows.length > 0 && hasWriteAccess(activeUser, "Lift") ? (
                  <ActionMenuButton>
                    <div className="actionBtn">
                      <img src={exportIcon} alt="Export to excel" />
                      <ExcelExport
                        rows={filteredRows}
                        columns={columns[activeMenu]}
                        filename={filename}
                      />
                    </div>
                  </ActionMenuButton>
                ) : (
                  <ActionMenuButton>
                    <div className="actionBtn">
                      <img
                        className={`${styles.icon} ${styles.disableImg}`}
                        src={exportIcon}
                        alt="Export to excel"
                      />
                      <span className={styles.disableText} style={{ textTransform: "capitalize" }}>
                        Export
                      </span>
                    </div>
                  </ActionMenuButton>
                )}

                {hasWriteAccess(activeUser, "Lift") && !isEditActive ? (
                  <ActionMenuButton
                    id="Add"
                    onClick={() => this.props.editActions.startEditing(newItem, true)}
                  >
                    <div className="actionBtn">
                      <img src={add} alt="Add new item" />
                      <span style={{ textTransform: "capitalize" }}>Add {activeMenu}</span>
                    </div>
                  </ActionMenuButton>
                ) :  (
                  <ActionMenuButton id="Add">
                    <div className="actionBtn">
                      <img src={add} className={styles.disableImg} alt="Add new item" />
                      <span style={{ textTransform: "capitalize" }} className={styles.disableText}>Add {activeMenu}</span>
                    </div>
                  </ActionMenuButton>
                )}
              </div>
              {
                <Popup
                  trigger={
                    <div className="tableSetting">
                      <ActionMenuButton>
                        <div className="actionBtn">
                          <img src={service} alt="Table settings" />
                          <span>Table Settings</span>
                        </div>
                      </ActionMenuButton>
                    </div>
                  }
                  wide="very"
                  content={
                    <div onClick={(e) => e.stopPropagation()}>
                      <GlobalTableSettings />
                    </div>
                  }
                  on="click"
                  position="bottom right"
                  className="tableSettingspopup"
                />
              }
            </div>
          )}
        </div>
        <div
          className={classNames({
            bindingsTabPanels: activeMenu === "Add Bindings" || activeMenu === "Remove Bindings",
            bindingsTabTable: activeMenu === "Products" || activeMenu === "Versions"
          })}
        >
          {activeMenu === "Add Bindings" && (
            <ModifyLiftParameterBindings
              mode="Add"
              liftParameters={liftParameters}
              kceProducts={pdApi.kceProducts}
              kceVersions={pdApi.kceVersions}
              updateLiftBindings={this.props.editActions.updateLiftBindings}
              permission={hasWriteAccess(activeUser, "Lift")}
            />
          )}
          {activeMenu === "Remove Bindings" && (
            <ModifyLiftParameterBindings
              mode="Remove"
              liftParameters={liftParameters}
              kceProducts={pdApi.kceProducts}
              kceVersions={pdApi.kceVersions}
              updateLiftBindings={this.props.editActions.updateLiftBindings}
              permission={hasWriteAccess(activeUser, "Lift")}
            />
          )}
          {activeMenu === "Versions" && (
            <>
            {/* NOTE: Table component column filtering shows lines with empty column value when entering text "null",
             this may be a bug in react-table. Workaround here is to pass "filteredRows" instead of "rows"  */}
              <VersionAndProduct
                {...this.props}
                subMenuRoute="Versions"
                toggleModal={this.toggleModal}
                rows={filteredRows}
                setColumnFilters={this.setColumnFilters}
                />
            </>
          )}
          {activeMenu === "Products" && (
            <>
              <VersionAndProduct
                {...this.props}
                subMenuRoute="Products"
                toggleModal={this.toggleModal}
                rows={filteredRows}
                setColumnFilters={this.setColumnFilters}
              />
            </>
          )}
        </div>
        {isEditActive && (
          <ConfirmationModal
            isOpen={isModalOpen}
            size="mini"
            header="Confirm delete"
            content={`Are you sure you want to delete ${option} ${objectIdentifier}`}
            confirmText="Confirm"
            cancelText="Cancel"
            onConfirm={() => this.props.editActions.delete(option)}
            onCancel={this.toggleModal}
          />
        )}
      </div>
    );
  }

  private toggleModal = (): void => {
    this.setState(prevState => ({
      isModalOpen: !prevState.isModalOpen
    }));
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterWithUserSelection(userFiltering: Filter[] | undefined, rows: any[]): any[] {
    if (!userFiltering || userFiltering.length === 0) {
      return rows;
    }
    const retval = rows.filter(
      row =>
        userFiltering?.every(filter => {
          const column: State.Column | undefined = this.props.columns[
            this.state.activeMenu as State.LiftBindingsSubmenuWithTables
          ].find((col: Column) => col.id === filter.id);
          const propertyPath = column?.ownAccessorName || "";
          const propertyPathArray = propertyPath.split(".").slice(1);
          const rowValue = getIndexedValue(propertyPathArray, row);
          const included =
            filter.value === "all"
              ? true
              : rowValue != null && !!filter.value
              ? column?.hasDropdownFiltering
                ? rowValue.toString() === filter.value.toString()
                : searchMatchRule(rowValue.toString(), filter.value.toString())
              : false;
          return included;
        }, this),
      this
    );
    return retval;
  }}

const mapStateToProps = (state: State.Root, ownProps: OwnProps) => ({
  columns: state.columns,
  pdApi: state.pdApi,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView),
  editedObjectId: editedObjectIdSelector(state.editView),
  objectIdentifier: editedObjectIdentifierSelector(state.editView, ownProps.subMenuRoute)
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions | ColumnActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  columnActions: bindActionCreators({ ...columnActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LiftBindings);
